export default function ErrorIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.792969"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        fill="#FF5F49"
      />
      <g clipPath="url(#clip0_1135_38321)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.50733 7.21435C7.8348 6.88688 8.36574 6.88688 8.69321 7.21435L12.293 10.8141L15.8927 7.21435C16.2202 6.88688 16.7511 6.88688 17.0786 7.21435C17.4061 7.54182 17.4061 8.07276 17.0786 8.40023L13.4788 12L17.0786 15.5998C17.4061 15.9272 17.4061 16.4582 17.0786 16.7856C16.7511 17.1131 16.2202 17.1131 15.8927 16.7856L12.293 13.1859L8.6932 16.7856C8.36573 17.1131 7.83479 17.1131 7.50732 16.7856C7.17985 16.4582 7.17985 15.9272 7.50732 15.5998L11.1071 12L7.50733 8.40023C7.17986 8.07276 7.17986 7.54182 7.50733 7.21435Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1135_38321">
          <rect
            width="11.5"
            height="11.5"
            fill="white"
            transform="translate(6.54297 6.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
